import React from 'react';
import PropTypes from 'prop-types';
import {getGroupsForStackedBreakdown} from 'common/utils/chart-util';
import Card from 'common/components/card';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import CardCallouts from 'common/components/card-callouts';
import TrendsChart from 'common/components/trends-chart';
import './index.scss';

export default class StackedBreakdownCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    data: PropTypes.object.isRequired,
    disableConfig: PropTypes.bool,
    report: PropTypes.object.isRequired,
    scheduleId: PropTypes.number,
  };

  static defaultProps = {
    connectDragSource: (x) => x,
    data: {},
    disableConfig: false,
  };

  getCardContentClassName(header) {
    return header ? '' : 'CardContent--no-header';
  }

  render() {
    const {meta} = this.props.report;
    const header = this.props.connectDragSource(
      <div>
        <CardHeader
          disableConfig={this.props.disableConfig}
          priorityWarnings={this.props.report.priorityWarnings}
          reportId={this.props.report.id}
          scheduleId={this.props.scheduleId}
          subtitle={meta.subtitle || meta.period.displayName}
          title={this.props.report.name}
          warnings={this.props.report.warnings}
        />
      </div>,
    );
    const cardContentClassName = this.getCardContentClassName(header);
    const groups = getGroupsForStackedBreakdown(this.props.report);
    return (
      <Card className={'StackedBreakdownCard'} loading={false}>
        {header}
        <CardContent className={cardContentClassName}>
          <TrendsChart
            groups={groups}
            gutters={{
              bottom: 18,
              left: 30,
              right: 30,
              top: 18,
            }}
          />
          <CardCallouts meta={this.props.report.meta} />
        </CardContent>
      </Card>
    );
  }
}
